import React from "react";
import { Input, InputProps, InputRef } from "antd";

export default function VtInput(
  props: React.JSX.IntrinsicAttributes &
    InputProps &
    React.RefAttributes<InputRef>
) {
  return <Input {...props} />;
}
